import { Component, Input } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';


@Component({
  selector: 'app-confirmdialog.component',
  templateUrl: './confirmdialog.component.html',
  styleUrl: './confirmdialog.component.css',
  standalone: false
})
export class ConfirmationDialogComponent {

  public confirmMessage: string;

  constructor(public dialogRef: MatDialogRef<ConfirmationDialogComponent>) { }


}
